"use strict";
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * Generated API
 * OpenAPI spec version: 1.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=availability.js.map